export default "__VITE_ASSET__1aeed396__"